import { StyledSvg } from "baseui/icon";
import React from "react";

export const AddIcon = (props: React.ComponentProps<typeof StyledSvg>) => (
  <StyledSvg viewBox="0 0 30 30" {...props} xmlns="http://www.w3.org/2000/svg">
    <path d="M16.4732 16.4732H23.8393C24.654 16.4732 25.3125 15.8132 25.3125 15C25.3125 14.1868 24.654 13.5268 23.8393 13.5268H16.4732V6.16071C16.4732 5.3475 15.8147 4.6875 15 4.6875C14.1853 4.6875 13.5268 5.3475 13.5268 6.16071V13.5268H6.16071C5.34603 13.5268 4.6875 14.1868 4.6875 15C4.6875 15.8132 5.34603 16.4732 6.16071 16.4732H13.5268V23.8393C13.5268 24.6525 14.1853 25.3125 15 25.3125C15.8147 25.3125 16.4732 24.6525 16.4732 23.8393V16.4732Z" />
  </StyledSvg>
);
